var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagMauritius(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_15980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.94543 8.34781L16 9.73913L30.0546 8.34781C27.3409 3.37431 22.0647 0 16 0C9.93531 0 4.65912 3.37431 1.94543 8.34781Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94544 23.6521L16 25.0435L30.0546 23.6521C31.2948 21.379 32 18.7718 32 16L16 14.6086L0 16C0 18.7718 0.705188 21.379 1.94544 23.6521Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.94544 8.3479C0.705188 10.6211 0 13.2282 0 16.0001H32C32 13.2282 31.2948 10.6211 30.0546 8.3479H16H1.94544Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 31.9999C22.0647 31.9999 27.3409 28.6256 30.0546 23.6521H1.94543C4.65912 28.6256 9.93531 31.9999 16 31.9999Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_15980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagMauritius);
export default __webpack_public_path__ + "static/media/flag_mauritius.c20d41923cfe46eb3d6b5539af3db523.svg";
export { ForwardRef as ReactComponent };